<template>
  <div v-if="isProMonthlyToAnnualBilledMonthlyUpgrade" class="opc-cart-item__text first-capitalize opc-next-renewal">
    {{ $t('billing.order_summary.next_renewal_date') }}
    <vloader :loading="isProratedLoading" :value="getProAnnualBilledMonthlyNextRenewalDate" />
    <zm-tooltip
      v-if="!isProratedLoading"
      :content="$t('billing.order_summary.next_renewal_date_tooltip')"
      role="button"
      disallow-learn-about
      aria-label="Learn more about Subscription Renewal Date"
    >
      <tips-icon type="info" aria-label="Learn more about Subscription Renewal Date" />
    </zm-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import vloader from '@/views/config/shopping-cart/prorated/vloader.vue';
import proAnnualBilledMonthlyMixin from '@/plans/ZOOM_MEETING/mixin/pro-annual-billed-monthly';

export default {
  name: 'NextRenewalDate',
  mixins: [proAnnualBilledMonthlyMixin],
  components: { vloader },
  computed: {
    ...mapGetters(['isProratedLoading'])
  }
};
</script>

<style lang="scss" scoped>
.opc-next-renewal {
  color: var(--zoom-color-text-neutral, #686F79);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
</style>
